module.exports = "<ul class=\"list-group text-left\" [ngClass]=\"{'collapsed':false}\">\n  <li class=\"list-group-item list-group-item-action transfers-option\" routerLink=\"abonoMonedero\" routerLinkActive=\"active\" (click)=\"selectedTransferOption(0)\">\n    <a class=\"text-submenu\">+ Monedero</a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src14910448/src/src/app/components/navigation/options/transfers/submenu/transfer-submenu.component.html
// module id = ../../../../../src/app/components/navigation/options/transfers/submenu/transfer-submenu.component.html
// module chunks = main